import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { AxiosInstance } from 'axios';
import {
  ManagePointSettingPayload,
  ManagePointSettingStatusPayload,
  ManageReferralStagePayload,
  ManageReferralStageStatusPayload,
  ManageReferralValidityPayload,
  PointCategoryAssignPayload,
  PointCategoryPayload,
  PointCategoryStatusPayload,
  PointCategoryUpdatePayload,
  PointSlabPayload,
  PointSlabStatusPayload,
  PointSlabUpdatePayload,
} from './pointConfiguration.types';

const createPointCategory = (client: AxiosInstance) => async (payload: PointCategoryPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.CREATE_POINT_CATEGORY, payload)).data;
};

const updatePointCategory = (client: AxiosInstance) => async (payload: PointCategoryUpdatePayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.UPDATE_POINT_CATEGORY, payload)).data;
};

const assignPointCategory = (client: AxiosInstance) => async (payload: PointCategoryAssignPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.ASSIGN_POINT_CATEGORY, payload)).data;
};

const updatePointCategoryStatus = (client: AxiosInstance) => async (payload: PointCategoryStatusPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.UPDATE_POINT_CATEGORY_STATUS, payload)).data;
};

const deletePointCategory =
  (client: AxiosInstance) => async (params: { pointCategoryId: string; agentType: string }) => {
    return (await client.delete<ApiResponse>(API_ROUTES.DELETE_POINT_CATEGORY, { params })).data;
  };

const createPointSlab = (client: AxiosInstance) => async (payload: PointSlabPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.CREATE_POINT_SLAB, payload)).data;
};

const updatePointSlab = (client: AxiosInstance) => async (payload: PointSlabUpdatePayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.UPDATE_POINT_SLAB, payload)).data;
};

const updatePointSlabStatus = (client: AxiosInstance) => async (payload: PointSlabStatusPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.UPDATE_POINT_SLAB_STATUS, payload)).data;
};

const deletePointSlab = (client: AxiosInstance) => async (pointSlabId: string) => {
  return (await client.delete<ApiResponse>(API_ROUTES.DELETE_POINT_SLAB, { params: { pointSlabId } })).data;
};

const manageReferralValidity = (client: AxiosInstance) => async (payload: ManageReferralValidityPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.MANAGE_REFERRAL_VALIDITY, payload)).data;
};

const managePointSetting = (client: AxiosInstance) => async (payload: ManagePointSettingPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.MANAGE_POINT_SETTING, payload)).data;
};

const managePointSettingStatus = (client: AxiosInstance) => async (payload: ManagePointSettingStatusPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.MANAGE_POINT_SETTING_STATUS, payload)).data;
};

const manageReferralStageStatus = (client: AxiosInstance) => async (payload: ManageReferralStageStatusPayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.MANAGE_REFERRAL_STAGE_STATUS, payload)).data;
};

const manageReferralStage = (client: AxiosInstance) => async (payload: ManageReferralStagePayload) => {
  return (await client.post<ApiResponse>(API_ROUTES.MANAGE_REFERRAL_STAGE, payload)).data;
};

export const pointConfigurationMutations = {
  createPointCategory,
  updatePointCategory,
  assignPointCategory,
  updatePointCategoryStatus,
  deletePointCategory,
  createPointSlab,
  updatePointSlab,
  updatePointSlabStatus,
  deletePointSlab,
  manageReferralValidity,
  manageReferralStageStatus,
  manageReferralStage,
  managePointSetting,
  managePointSettingStatus,
};
